import { jwtDecode } from 'jwt-decode';

/**
 * Safely decodes a JWT token. Returns null if the token is invalid or missing.
 * @param {string|null|undefined} token - The JWT token to decode
 * @returns {object|null} The decoded token payload, or null if invalid
 */
const safeJwtDecode = (token) => {
	if (!token) {
		return null;
	}

	try {
		return jwtDecode(token);
	} catch (e) {
		return null;
	}
};

export default safeJwtDecode;
